/* eslint-disable */
import axios from 'axios';
const baseInstance = axios.create();

baseInstance.interceptors.request.use(
  function(config) {
    return config;
  },
  function(error) {
    // TODO: Call global message handler, or set stub response from tests/fixtures.
    console.error('API call error', error);
    return Promise.reject(error);
  },
);

class HttpRequest {
  constructor(instance = baseInstance) {
    this.instance = instance;
  }

  setHeader(header) {
    instance.defaults.headers.common[header.key] = header.value;
  }

  fetch(url, props) {
    return this.instance.get(url, props);
  }

  delete(url, props) {
    return this.instance.delete(url, props);
  }

  post(url, props) {
    return this.instance.post(url, props);
  }

  patch(url, props) {
    return this.instance.patch(url, props);
  }

  put(url, props) {
    return this.instance.put(url, props);
  }

  request(type, url, data) {
    let promise = null;
    switch (type) {
      case 'GET':
        promise = this.instance.get(url, { params: data });
        break;
      case 'POST':
        promise = this.instance.post(url, data);
        break;
      case 'PUT':
        promise = this.instance.put(url, data);
        break;
      case 'DELETE':
        promise = this.instance.delete(url, data);
        break;
      default:
        promise = this.instance.get(url, { params: data });
        break;
    }
    return promise;
  }
}

export default HttpRequest;
